import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Journey, Correction, CorrectionFactory } from '@lighty';
import { combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'msc-learn-detail-journey-correction',
    templateUrl: './correction.component.html'
})
export class LearnDetailJourneyCorrectionComponent implements OnInit {
    public journey: Journey;
    public corrections: Correction[];
    public contents: any;

    constructor(private route: ActivatedRoute, private factory: CorrectionFactory) {}

    // route.parent.data.journey/corrections ya no son los objetos directos -- son
    // { journey$ }/{ corrections$ } (JourneyResolver/JourneyDetailsCorrectionsResolver ya no
    // bloquean la navegación, ver learn.resolver.ts). Nos suscribimos a ambos en vez de leer el
    // snapshot síncrono.
    ngOnInit(): void {
        this.route.parent.data.pipe(
            switchMap((data: any) => combineLatest([data.journey.journey$, data.corrections.corrections$]))
        ).subscribe((result: any[]) => {
            const [journey, corrections] = result;
            this.journey = journey;
            this.contents = corrections;

            this.corrections = (corrections || [])
                .filter(content => content.corrections && content.corrections.length)
                .map(content => content.corrections)
                .map(group => {
                    return group.map(correction => {
                        if (correction.corrections.length === 0) {
                            return null;
                        }
                        return this.factory.get([].concat(correction.corrections).shift(), correction.context, correction.title, correction.description);
                    });
                })
                .map(group => {
                    return group.filter(correction => correction);
                });
        });
    }
}
